import { ArteComponent } from "../../Components/Galeria/ArteComponent";
import { LogoHeader } from '../../Components/Inicio/LogoHeaderComponent';
import { NavDesktop } from '../../Components/Inicio/NavDesktop';
import { NavMobile } from '../../Components/Inicio/NavMobile';
import { Footer } from '../../Components/Footer/FooterComponent';

export const ArteFallero = (props) =>{
    return(
        <>
        <LogoHeader I18n={props.I18n} />
        <NavDesktop I18n={props.I18n} />
        <NavMobile I18n={props.I18n} />
        <ArteComponent Data={props.Data} I18n={props.I18n} />
        <Footer I18n={props.I18n} />
        </>
    )
}